/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chot_So_Col_ApproverInputs */

const vi_chot_so_col_approver = /** @type {(inputs: Chot_So_Col_ApproverInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Người duyệt`)
};

/**

* @param {Chot_So_Col_ApproverInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const chot_so_col_approver = /** @type {((inputs?: Chot_So_Col_ApproverInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chot_So_Col_ApproverInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_chot_so_col_approver(inputs)
});